// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.4
// source: events/platform/web/events.proto

/* eslint-disable */
import {
  Sport,
  sportFromJSON,
  sportToJSON,
} from '#src/protos/events/shared/events.ts';

export const protobufPackage = 'events.platform.web';

export enum CashWalletStatus {
  PAYER = 0,
  OWNER = 1,
  VALIDATED_OWNER = 2,
  UNRECOGNIZED = -1,
}

export function cashWalletStatusFromJSON(object: any): CashWalletStatus {
  switch (object) {
    case 0:
    case 'PAYER':
      return CashWalletStatus.PAYER;
    case 1:
    case 'OWNER':
      return CashWalletStatus.OWNER;
    case 2:
    case 'VALIDATED_OWNER':
      return CashWalletStatus.VALIDATED_OWNER;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CashWalletStatus.UNRECOGNIZED;
  }
}

export function cashWalletStatusToJSON(object: CashWalletStatus): string {
  switch (object) {
    case CashWalletStatus.PAYER:
      return 'PAYER';
    case CashWalletStatus.OWNER:
      return 'OWNER';
    case CashWalletStatus.VALIDATED_OWNER:
      return 'VALIDATED_OWNER';
    case CashWalletStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export enum Wallet {
  FIAT = 0,
  ETH = 1,
  UNRECOGNIZED = -1,
}

export function walletFromJSON(object: any): Wallet {
  switch (object) {
    case 0:
    case 'FIAT':
      return Wallet.FIAT;
    case 1:
    case 'ETH':
      return Wallet.ETH;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return Wallet.UNRECOGNIZED;
  }
}

export function walletToJSON(object: Wallet): string {
  switch (object) {
    case Wallet.FIAT:
      return 'FIAT';
    case Wallet.ETH:
      return 'ETH';
    case Wallet.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export enum DepositMethod {
  CREDIT_CARD = 0,
  NEW_CREDIT_CARD = 1,
  PAYPAL = 2,
  IDEAL = 3,
  WIRE = 4,
  APPLE_PAY = 5,
  UNRECOGNIZED = -1,
}

export function depositMethodFromJSON(object: any): DepositMethod {
  switch (object) {
    case 0:
    case 'CREDIT_CARD':
      return DepositMethod.CREDIT_CARD;
    case 1:
    case 'NEW_CREDIT_CARD':
      return DepositMethod.NEW_CREDIT_CARD;
    case 2:
    case 'PAYPAL':
      return DepositMethod.PAYPAL;
    case 3:
    case 'IDEAL':
      return DepositMethod.IDEAL;
    case 4:
    case 'WIRE':
      return DepositMethod.WIRE;
    case 5:
    case 'APPLE_PAY':
      return DepositMethod.APPLE_PAY;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return DepositMethod.UNRECOGNIZED;
  }
}

export function depositMethodToJSON(object: DepositMethod): string {
  switch (object) {
    case DepositMethod.CREDIT_CARD:
      return 'CREDIT_CARD';
    case DepositMethod.NEW_CREDIT_CARD:
      return 'NEW_CREDIT_CARD';
    case DepositMethod.PAYPAL:
      return 'PAYPAL';
    case DepositMethod.IDEAL:
      return 'IDEAL';
    case DepositMethod.WIRE:
      return 'WIRE';
    case DepositMethod.APPLE_PAY:
      return 'APPLE_PAY';
    case DepositMethod.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export enum FiatCurrency {
  UNKNOWN_CURRENCY = 0,
  EUR = 1,
  USD = 2,
  GBP = 3,
  UNRECOGNIZED = -1,
}

export function fiatCurrencyFromJSON(object: any): FiatCurrency {
  switch (object) {
    case 0:
    case 'UNKNOWN_CURRENCY':
      return FiatCurrency.UNKNOWN_CURRENCY;
    case 1:
    case 'EUR':
      return FiatCurrency.EUR;
    case 2:
    case 'USD':
      return FiatCurrency.USD;
    case 3:
    case 'GBP':
      return FiatCurrency.GBP;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return FiatCurrency.UNRECOGNIZED;
  }
}

export function fiatCurrencyToJSON(object: FiatCurrency): string {
  switch (object) {
    case FiatCurrency.UNKNOWN_CURRENCY:
      return 'UNKNOWN_CURRENCY';
    case FiatCurrency.EUR:
      return 'EUR';
    case FiatCurrency.USD:
      return 'USD';
    case FiatCurrency.GBP:
      return 'GBP';
    case FiatCurrency.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ReferralCardBought {
  referralId: string;
  sport: Sport;
  /**
   * card_slug should be used
   *
   * @deprecated
   */
  cardSlugs: string[];
  cardSlug: string;
  /**
   * player_slug should be used
   *
   * @deprecated
   */
  playerSlugs: string[];
  playerSlug: string;
  positions: string[];
  season: number;
  teamSlug: string;
  cardCount: number;
  limited: number;
  rare: number;
  superRare: number;
  unique: number;
  auctionId: string;
  primaryOfferId: string;
  count: number;
  ethAmount: number;
  eurAmount: number;
  conversionCreditEthAmount: number;
  conversionCreditEurAmount: number;
  fiatPayment: boolean;
  secondary: boolean;
  footballCardsBought: number;
  baseballCardsBought: number;
  nbaCardsBought: number;
}

export interface ReferralCompleted {
  referralId: string;
  sport: Sport;
  footballCardsBought: number;
  baseballCardsBought: number;
  nbaCardsBought: number;
}

export interface ReferralRewardSent {
  referralId: string;
  sport: Sport;
  cardSlug: string;
  playerSlug: string;
  positions: string[];
  scarcity: string;
  season: number;
  serialNumber: number;
  teamSlug: string;
  position: string;
  conversionCreditEurAmount: number;
  conversionCreditPercentageDiscount: number;
  conversionCreditDuration: number;
}

export interface ClickListAgain {
  cardSlug: string;
}

export interface UserFlagToggled {
  flag: string;
}

export interface ClickTrade {
  interactionContext: string;
  offerId: string;
}

export interface ChooseSignupSport {
  sport: Sport;
}

export interface ChooseSignupManagerName {}

/** manager name invalid or already taken */
export interface FailSignupManagerName {}

export interface ClickSignupByEmail {}

/** invalid email or password */
export interface FailSignupByEmail {}

export interface ClickSignupByOAuth {
  provider: string;
}

export interface SubmitSignUpForm {
  interactionContext: string;
}

export interface ClearMarketFilters {
  interactionContext: string;
  sport: Sport;
  filtersCount: number;
}

export interface RemoveMarketFilterChip {
  interactionContext: string;
  sport: Sport;
  filterName: string;
  filterValue: string;
}

export interface SetDefaultMarketFilters {
  interactionContext: string;
  sport: Sport;
  filters: { [key: string]: string };
}

export interface SetDefaultMarketFilters_FiltersEntry {
  key: string;
  value: string;
}

export interface ClearDefaultMarketFilters {
  interactionContext: string;
  sport: Sport;
}

export interface ConfirmPurchaseForm {
  interactionContext: string;
  ethAmount: number;
  eurAmount: number;
  fiatPayment: boolean;
  sport: Sport;
  offerId: string;
  isV2?: boolean | undefined;
}

export interface ClickAnnouncementLink {
  announcementId: string;
  announcementTitle: string;
  linkHref: string;
}

export interface CreateSavedSearch {
  name: string;
  filters: { [key: string]: string };
  interactionContext: string;
  sport: Sport;
}

export interface CreateSavedSearch_FiltersEntry {
  key: string;
  value: string;
}

export interface SelectSavedSearch {
  name: string;
  filters: { [key: string]: string };
  interactionContext: string;
  sport: Sport;
}

export interface SelectSavedSearch_FiltersEntry {
  key: string;
  value: string;
}

export interface DeleteSavedSearch {
  name: string;
  filters: { [key: string]: string };
  interactionContext: string;
  sport: Sport;
}

export interface DeleteSavedSearch_FiltersEntry {
  key: string;
  value: string;
}

export interface SwitchStackedView {
  stacked: boolean;
  sport: Sport;
}

export interface ClickStack {
  playerSlug: string;
  scarcity: string;
  season: number;
  teamSlug: string;
  interactionContext: string;
  sport: Sport;
}

export interface ClickMarketTrend {
  timeframe: string;
  trend: string;
  slug: string;
  interactionContext: string;
  sport: Sport;
}

export interface LoadMarketTrends {
  timeframe: string;
  sales: string[];
  onTheRise: string[];
  volumes: string[];
  interactionContext: string;
  sport: Sport;
}

export interface UserCategoryUpdated {
  category: string;
}

export interface KycDocumentSubmitted {
  country: string;
  documentType: string;
}

export interface KycDocumentRefused {
  country: string;
  documentType: string;
  reasonType: string;
}

export interface FailCardRegistration {
  cardType: string;
  interactionContext: string;
  sport: Sport;
}

export interface ClickReferralBanner {
  interactionContext: string;
  sport: Sport;
}

export interface CampaignPageVisited {
  url: string;
  fingerprint: string;
  identifierType: string;
}

export interface ClickScoutCards {
  interactionContext: string;
  sport: Sport;
  playerSlug: string;
}

export interface ClickSeeAllAvailableCards {
  interactionContext: string;
  sport: Sport;
  eventName: string;
  eventType: string;
}

export interface ClickSeeOtherListingsFromEndedAuction {}

export interface ViewBlogPost {
  slug: string;
}

export interface ReadBlogPost {
  slug: string;
}

export interface ClickHelp {
  interactionContext: string;
  sport: Sport;
}

export interface ViewHelpCenterArticle {
  id: string;
  locale: string;
  title: string;
}

export interface ClickOpenMobileApp {
  interactionContext: string;
  sport: Sport;
  platform: string;
}

export interface ClosePromoteMobileApp {
  interactionContext: string;
  sport: Sport;
  platform: string;
}

export interface EnterCashWalletKYCFlow {
  interactionContext: string;
  sport: Sport;
  source: EnterCashWalletKYCFlow_Source;
  target: EnterCashWalletKYCFlow_Target;
  cashWalletStatus: CashWalletStatus;
  fiatCurrency: string;
}

export enum EnterCashWalletKYCFlow_Source {
  WALLET_CTA = 0,
  WALLET_DEPOSIT_HELPER = 1,
  WALLET_WITHDRAW_HELPER = 2,
  WALLET_FIAT_ONLY_ADD_FUNDS_CTA = 4,
  WALLET_FIAT_ONLY_WITHDRAW_CTA = 5,
  SETTINGS_CASH_AND_ETH_RECEIVED_PAYMENT_HELPER = 6,
  SETTINGS_CASH_ONLY_RECEIVED_PAYMENT_HELPER = 7,
  SETTINGS_CASH_COMPETITION_REWARDS_HELPER = 8,
  LIST_A_CARD = 9,
  FIRST_CASH_REWARD = 10,
  MIGRATION_MODAL = 11,
  REJECTED_KYC_NOTIFICATION = 12,
  REJECTED_KYC_EMAIL = 13,
  ACCEPT_TRADE_OFFER = 14,
  COUNTEROFFER_TRADE_OFFER = 15,
  CUSTOM_LEAGUE_ONBOARDING = 16,
  UNRECOGNIZED = -1,
}

export function enterCashWalletKYCFlow_SourceFromJSON(
  object: any
): EnterCashWalletKYCFlow_Source {
  switch (object) {
    case 0:
    case 'WALLET_CTA':
      return EnterCashWalletKYCFlow_Source.WALLET_CTA;
    case 1:
    case 'WALLET_DEPOSIT_HELPER':
      return EnterCashWalletKYCFlow_Source.WALLET_DEPOSIT_HELPER;
    case 2:
    case 'WALLET_WITHDRAW_HELPER':
      return EnterCashWalletKYCFlow_Source.WALLET_WITHDRAW_HELPER;
    case 4:
    case 'WALLET_FIAT_ONLY_ADD_FUNDS_CTA':
      return EnterCashWalletKYCFlow_Source.WALLET_FIAT_ONLY_ADD_FUNDS_CTA;
    case 5:
    case 'WALLET_FIAT_ONLY_WITHDRAW_CTA':
      return EnterCashWalletKYCFlow_Source.WALLET_FIAT_ONLY_WITHDRAW_CTA;
    case 6:
    case 'SETTINGS_CASH_AND_ETH_RECEIVED_PAYMENT_HELPER':
      return EnterCashWalletKYCFlow_Source.SETTINGS_CASH_AND_ETH_RECEIVED_PAYMENT_HELPER;
    case 7:
    case 'SETTINGS_CASH_ONLY_RECEIVED_PAYMENT_HELPER':
      return EnterCashWalletKYCFlow_Source.SETTINGS_CASH_ONLY_RECEIVED_PAYMENT_HELPER;
    case 8:
    case 'SETTINGS_CASH_COMPETITION_REWARDS_HELPER':
      return EnterCashWalletKYCFlow_Source.SETTINGS_CASH_COMPETITION_REWARDS_HELPER;
    case 9:
    case 'LIST_A_CARD':
      return EnterCashWalletKYCFlow_Source.LIST_A_CARD;
    case 10:
    case 'FIRST_CASH_REWARD':
      return EnterCashWalletKYCFlow_Source.FIRST_CASH_REWARD;
    case 11:
    case 'MIGRATION_MODAL':
      return EnterCashWalletKYCFlow_Source.MIGRATION_MODAL;
    case 12:
    case 'REJECTED_KYC_NOTIFICATION':
      return EnterCashWalletKYCFlow_Source.REJECTED_KYC_NOTIFICATION;
    case 13:
    case 'REJECTED_KYC_EMAIL':
      return EnterCashWalletKYCFlow_Source.REJECTED_KYC_EMAIL;
    case 14:
    case 'ACCEPT_TRADE_OFFER':
      return EnterCashWalletKYCFlow_Source.ACCEPT_TRADE_OFFER;
    case 15:
    case 'COUNTEROFFER_TRADE_OFFER':
      return EnterCashWalletKYCFlow_Source.COUNTEROFFER_TRADE_OFFER;
    case 16:
    case 'CUSTOM_LEAGUE_ONBOARDING':
      return EnterCashWalletKYCFlow_Source.CUSTOM_LEAGUE_ONBOARDING;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return EnterCashWalletKYCFlow_Source.UNRECOGNIZED;
  }
}

export function enterCashWalletKYCFlow_SourceToJSON(
  object: EnterCashWalletKYCFlow_Source
): string {
  switch (object) {
    case EnterCashWalletKYCFlow_Source.WALLET_CTA:
      return 'WALLET_CTA';
    case EnterCashWalletKYCFlow_Source.WALLET_DEPOSIT_HELPER:
      return 'WALLET_DEPOSIT_HELPER';
    case EnterCashWalletKYCFlow_Source.WALLET_WITHDRAW_HELPER:
      return 'WALLET_WITHDRAW_HELPER';
    case EnterCashWalletKYCFlow_Source.WALLET_FIAT_ONLY_ADD_FUNDS_CTA:
      return 'WALLET_FIAT_ONLY_ADD_FUNDS_CTA';
    case EnterCashWalletKYCFlow_Source.WALLET_FIAT_ONLY_WITHDRAW_CTA:
      return 'WALLET_FIAT_ONLY_WITHDRAW_CTA';
    case EnterCashWalletKYCFlow_Source.SETTINGS_CASH_AND_ETH_RECEIVED_PAYMENT_HELPER:
      return 'SETTINGS_CASH_AND_ETH_RECEIVED_PAYMENT_HELPER';
    case EnterCashWalletKYCFlow_Source.SETTINGS_CASH_ONLY_RECEIVED_PAYMENT_HELPER:
      return 'SETTINGS_CASH_ONLY_RECEIVED_PAYMENT_HELPER';
    case EnterCashWalletKYCFlow_Source.SETTINGS_CASH_COMPETITION_REWARDS_HELPER:
      return 'SETTINGS_CASH_COMPETITION_REWARDS_HELPER';
    case EnterCashWalletKYCFlow_Source.LIST_A_CARD:
      return 'LIST_A_CARD';
    case EnterCashWalletKYCFlow_Source.FIRST_CASH_REWARD:
      return 'FIRST_CASH_REWARD';
    case EnterCashWalletKYCFlow_Source.MIGRATION_MODAL:
      return 'MIGRATION_MODAL';
    case EnterCashWalletKYCFlow_Source.REJECTED_KYC_NOTIFICATION:
      return 'REJECTED_KYC_NOTIFICATION';
    case EnterCashWalletKYCFlow_Source.REJECTED_KYC_EMAIL:
      return 'REJECTED_KYC_EMAIL';
    case EnterCashWalletKYCFlow_Source.ACCEPT_TRADE_OFFER:
      return 'ACCEPT_TRADE_OFFER';
    case EnterCashWalletKYCFlow_Source.COUNTEROFFER_TRADE_OFFER:
      return 'COUNTEROFFER_TRADE_OFFER';
    case EnterCashWalletKYCFlow_Source.CUSTOM_LEAGUE_ONBOARDING:
      return 'CUSTOM_LEAGUE_ONBOARDING';
    case EnterCashWalletKYCFlow_Source.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export enum EnterCashWalletKYCFlow_Target {
  OWNER = 0,
  VALIDATED_OWNER = 1,
  OPTIONAL_VALIDATED_OWNER = 2,
  UNRECOGNIZED = -1,
}

export function enterCashWalletKYCFlow_TargetFromJSON(
  object: any
): EnterCashWalletKYCFlow_Target {
  switch (object) {
    case 0:
    case 'OWNER':
      return EnterCashWalletKYCFlow_Target.OWNER;
    case 1:
    case 'VALIDATED_OWNER':
      return EnterCashWalletKYCFlow_Target.VALIDATED_OWNER;
    case 2:
    case 'OPTIONAL_VALIDATED_OWNER':
      return EnterCashWalletKYCFlow_Target.OPTIONAL_VALIDATED_OWNER;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return EnterCashWalletKYCFlow_Target.UNRECOGNIZED;
  }
}

export function enterCashWalletKYCFlow_TargetToJSON(
  object: EnterCashWalletKYCFlow_Target
): string {
  switch (object) {
    case EnterCashWalletKYCFlow_Target.OWNER:
      return 'OWNER';
    case EnterCashWalletKYCFlow_Target.VALIDATED_OWNER:
      return 'VALIDATED_OWNER';
    case EnterCashWalletKYCFlow_Target.OPTIONAL_VALIDATED_OWNER:
      return 'OPTIONAL_VALIDATED_OWNER';
    case EnterCashWalletKYCFlow_Target.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ExitCashWalletKYCFlow {
  interactionContext: string;
  sport: Sport;
  kycExitStep: ExitCashWalletKYCFlow_ExitStep;
  cashWalletStatus: CashWalletStatus;
  fiatCurrency: string;
}

export enum ExitCashWalletKYCFlow_ExitStep {
  ACTIVATE_YOUR_CASH_WALLET = 0,
  WHATS_NEW = 1,
  INTRO = 2,
  TELL_US_ABOUT_YOU = 3,
  CHOOSE_CURRENCY = 4,
  ACTIVATION_SUCCESS = 5,
  CHOOSE_DOCUMENT = 6,
  UPLOAD = 7,
  HANDLE_ID_REVIEW_ERROR = 8,
  DOCUMENT_UNDER_REVIEW = 9,
  REVIEW_INFO_BEFORE_ADDING_ID = 10,
  REVIEW_INFORMATION = 11,
  UNRECOGNIZED = -1,
}

export function exitCashWalletKYCFlow_ExitStepFromJSON(
  object: any
): ExitCashWalletKYCFlow_ExitStep {
  switch (object) {
    case 0:
    case 'ACTIVATE_YOUR_CASH_WALLET':
      return ExitCashWalletKYCFlow_ExitStep.ACTIVATE_YOUR_CASH_WALLET;
    case 1:
    case 'WHATS_NEW':
      return ExitCashWalletKYCFlow_ExitStep.WHATS_NEW;
    case 2:
    case 'INTRO':
      return ExitCashWalletKYCFlow_ExitStep.INTRO;
    case 3:
    case 'TELL_US_ABOUT_YOU':
      return ExitCashWalletKYCFlow_ExitStep.TELL_US_ABOUT_YOU;
    case 4:
    case 'CHOOSE_CURRENCY':
      return ExitCashWalletKYCFlow_ExitStep.CHOOSE_CURRENCY;
    case 5:
    case 'ACTIVATION_SUCCESS':
      return ExitCashWalletKYCFlow_ExitStep.ACTIVATION_SUCCESS;
    case 6:
    case 'CHOOSE_DOCUMENT':
      return ExitCashWalletKYCFlow_ExitStep.CHOOSE_DOCUMENT;
    case 7:
    case 'UPLOAD':
      return ExitCashWalletKYCFlow_ExitStep.UPLOAD;
    case 8:
    case 'HANDLE_ID_REVIEW_ERROR':
      return ExitCashWalletKYCFlow_ExitStep.HANDLE_ID_REVIEW_ERROR;
    case 9:
    case 'DOCUMENT_UNDER_REVIEW':
      return ExitCashWalletKYCFlow_ExitStep.DOCUMENT_UNDER_REVIEW;
    case 10:
    case 'REVIEW_INFO_BEFORE_ADDING_ID':
      return ExitCashWalletKYCFlow_ExitStep.REVIEW_INFO_BEFORE_ADDING_ID;
    case 11:
    case 'REVIEW_INFORMATION':
      return ExitCashWalletKYCFlow_ExitStep.REVIEW_INFORMATION;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ExitCashWalletKYCFlow_ExitStep.UNRECOGNIZED;
  }
}

export function exitCashWalletKYCFlow_ExitStepToJSON(
  object: ExitCashWalletKYCFlow_ExitStep
): string {
  switch (object) {
    case ExitCashWalletKYCFlow_ExitStep.ACTIVATE_YOUR_CASH_WALLET:
      return 'ACTIVATE_YOUR_CASH_WALLET';
    case ExitCashWalletKYCFlow_ExitStep.WHATS_NEW:
      return 'WHATS_NEW';
    case ExitCashWalletKYCFlow_ExitStep.INTRO:
      return 'INTRO';
    case ExitCashWalletKYCFlow_ExitStep.TELL_US_ABOUT_YOU:
      return 'TELL_US_ABOUT_YOU';
    case ExitCashWalletKYCFlow_ExitStep.CHOOSE_CURRENCY:
      return 'CHOOSE_CURRENCY';
    case ExitCashWalletKYCFlow_ExitStep.ACTIVATION_SUCCESS:
      return 'ACTIVATION_SUCCESS';
    case ExitCashWalletKYCFlow_ExitStep.CHOOSE_DOCUMENT:
      return 'CHOOSE_DOCUMENT';
    case ExitCashWalletKYCFlow_ExitStep.UPLOAD:
      return 'UPLOAD';
    case ExitCashWalletKYCFlow_ExitStep.HANDLE_ID_REVIEW_ERROR:
      return 'HANDLE_ID_REVIEW_ERROR';
    case ExitCashWalletKYCFlow_ExitStep.DOCUMENT_UNDER_REVIEW:
      return 'DOCUMENT_UNDER_REVIEW';
    case ExitCashWalletKYCFlow_ExitStep.REVIEW_INFO_BEFORE_ADDING_ID:
      return 'REVIEW_INFO_BEFORE_ADDING_ID';
    case ExitCashWalletKYCFlow_ExitStep.REVIEW_INFORMATION:
      return 'REVIEW_INFORMATION';
    case ExitCashWalletKYCFlow_ExitStep.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ClickMarketTrendsLink {
  interactionContext: string;
  sport: Sport;
  tileType: ClickMarketTrendsLink_TileType;
  playerSlug?: string | undefined;
  scarcity?: string | undefined;
  serialNumber?: number | undefined;
  gameWeek?: number | undefined;
  heuristic: ClickMarketTrendsLink_ForYouHeuristic;
  so5LeagueSlug?: string | undefined;
  userSlug?: string | undefined;
}

export enum ClickMarketTrendsLink_TileType {
  CARD = 0,
  PLAYER = 1,
  TITLE = 2,
  UNRECOGNIZED = -1,
}

export function clickMarketTrendsLink_TileTypeFromJSON(
  object: any
): ClickMarketTrendsLink_TileType {
  switch (object) {
    case 0:
    case 'CARD':
      return ClickMarketTrendsLink_TileType.CARD;
    case 1:
    case 'PLAYER':
      return ClickMarketTrendsLink_TileType.PLAYER;
    case 2:
    case 'TITLE':
      return ClickMarketTrendsLink_TileType.TITLE;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickMarketTrendsLink_TileType.UNRECOGNIZED;
  }
}

export function clickMarketTrendsLink_TileTypeToJSON(
  object: ClickMarketTrendsLink_TileType
): string {
  switch (object) {
    case ClickMarketTrendsLink_TileType.CARD:
      return 'CARD';
    case ClickMarketTrendsLink_TileType.PLAYER:
      return 'PLAYER';
    case ClickMarketTrendsLink_TileType.TITLE:
      return 'TITLE';
    case ClickMarketTrendsLink_TileType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export enum ClickMarketTrendsLink_ForYouHeuristic {
  HOT_STREAK = 0,
  POPULAR = 1,
  FRIENDS_RECENT_PURCHASES = 2,
  WINNING_LINEUP = 3,
  INCOMPLETE_CARD_COLLECTION = 4,
  UNAVAILABLE_PLAYERS_SUBSTITUES = 5,
  TOP_PLAYERS = 6,
  UNRECOGNIZED = -1,
}

export function clickMarketTrendsLink_ForYouHeuristicFromJSON(
  object: any
): ClickMarketTrendsLink_ForYouHeuristic {
  switch (object) {
    case 0:
    case 'HOT_STREAK':
      return ClickMarketTrendsLink_ForYouHeuristic.HOT_STREAK;
    case 1:
    case 'POPULAR':
      return ClickMarketTrendsLink_ForYouHeuristic.POPULAR;
    case 2:
    case 'FRIENDS_RECENT_PURCHASES':
      return ClickMarketTrendsLink_ForYouHeuristic.FRIENDS_RECENT_PURCHASES;
    case 3:
    case 'WINNING_LINEUP':
      return ClickMarketTrendsLink_ForYouHeuristic.WINNING_LINEUP;
    case 4:
    case 'INCOMPLETE_CARD_COLLECTION':
      return ClickMarketTrendsLink_ForYouHeuristic.INCOMPLETE_CARD_COLLECTION;
    case 5:
    case 'UNAVAILABLE_PLAYERS_SUBSTITUES':
      return ClickMarketTrendsLink_ForYouHeuristic.UNAVAILABLE_PLAYERS_SUBSTITUES;
    case 6:
    case 'TOP_PLAYERS':
      return ClickMarketTrendsLink_ForYouHeuristic.TOP_PLAYERS;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickMarketTrendsLink_ForYouHeuristic.UNRECOGNIZED;
  }
}

export function clickMarketTrendsLink_ForYouHeuristicToJSON(
  object: ClickMarketTrendsLink_ForYouHeuristic
): string {
  switch (object) {
    case ClickMarketTrendsLink_ForYouHeuristic.HOT_STREAK:
      return 'HOT_STREAK';
    case ClickMarketTrendsLink_ForYouHeuristic.POPULAR:
      return 'POPULAR';
    case ClickMarketTrendsLink_ForYouHeuristic.FRIENDS_RECENT_PURCHASES:
      return 'FRIENDS_RECENT_PURCHASES';
    case ClickMarketTrendsLink_ForYouHeuristic.WINNING_LINEUP:
      return 'WINNING_LINEUP';
    case ClickMarketTrendsLink_ForYouHeuristic.INCOMPLETE_CARD_COLLECTION:
      return 'INCOMPLETE_CARD_COLLECTION';
    case ClickMarketTrendsLink_ForYouHeuristic.UNAVAILABLE_PLAYERS_SUBSTITUES:
      return 'UNAVAILABLE_PLAYERS_SUBSTITUES';
    case ClickMarketTrendsLink_ForYouHeuristic.TOP_PLAYERS:
      return 'TOP_PLAYERS';
    case ClickMarketTrendsLink_ForYouHeuristic.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ClickAddMoney {
  wallet: Wallet;
  currency?: FiatCurrency | undefined;
}

export interface SelectDepositMethod {
  method: DepositMethod;
}

export interface ClickReviewDeposit {
  method: DepositMethod;
  amount: number;
  currency: FiatCurrency;
  baseAmount?: number | undefined;
}

export interface ViewAddFundsToFiatWallet {
  currency: FiatCurrency;
  baseAmount?: number | undefined;
}

export interface ClickConfirmDesposit {
  method: DepositMethod;
  amount: number;
  currency: FiatCurrency;
}

export interface Display3ds {}

export interface ClickPaypalDepositFromPayment {
  canDeposit: boolean;
}

export interface SendDirectOffer {
  offerId: string;
}

export interface AcceptDirectOffer {
  offerId: string;
}

export interface ShowEnterPhoneNumber {}

export interface SubmitPhoneNumber {
  resend?: boolean | undefined;
}

export interface ShowEnterVerificationCode {}

export interface SubmitPhoneVerificationCode {}

export interface ClickLobbyLiveOpsTile {
  tileId: string;
  tileTitle: string;
  tilePosition: number;
}

export interface EnterFromAndroidMarketplaceTab {
  interactionContext: string;
  sport: Sport;
  appBuildVersion: string;
  userSlug?: string | undefined;
}

export interface ClickHomepageCryptoWalletIcon {}

export interface ClickHomepageCryptoWalletProvider {
  provider: string;
}

export interface ClickNotification {
  name: string;
}

export interface ClickNextInDiscountScreen {}

export interface ClickViewPlayersInDiscountScreen {}

export interface ClickSkipInDiscountScreen {}

export interface ClickScoutInDiscountScreen {}

export interface ClickMissionButton {
  slug: string;
  onboarding: boolean;
}

export interface ViewScrapScreen {
  cardsCount: number;
}

export interface ClickContinueInChooseYourLevel {
  scarcity: string;
}

export interface ClickNextInGuidanceTutorial {}

export interface ClickRewardInfoInGuidanceTutorial {}

export interface SelectCompetitionInGuidance {
  competition: string;
}

export interface ClickNextInGuidanceClubChoice {
  clubsCount: number;
  teamSlugs: string[];
}

export interface ClickSkipInGuidanceTeam {}

export interface ClickContinueInGuidanceTeam {}

export interface CheckPlayerDetailsInGuidanceTeam {}

export interface ClickEditTeamInGuidanceFirstLineup {}

export interface CheckPlayerDetailsInGuidanceFirstLineup {}

export interface ClickPrizePoolInGuidanceFirstLineup {}

export interface ClickHelpCenterInGuidanceFirstLineup {}

export interface ClickSwitchLeagueInGuidanceFirstLineup {}

export interface ClickCommonInGuidanceFirstLineup {}

export interface ClickCheckoutInGuidanceFirstLineup {}

export interface ClickShuffleInEditFirstLineup {}

export interface SwapPlayerInEditFirstLineup {
  oldPlayer: string;
  newPlayer: string;
}

export interface ClickLandingPagePromoBanner {
  clickSource?: string | undefined;
}

export interface ClickLandingPageScout {
  clickSource?: string | undefined;
}

export interface ClickLandingPagePlay {
  clickSource?: string | undefined;
}

export interface ClickLandingPageWin {
  clickSource?: string | undefined;
}

export interface LandingPageNicknameForm {
  source: string;
  status: string;
}

export interface ClickSkipCollectionAnimation {}

export const ReferralCardBought: MessageFns<ReferralCardBought> = {
  fromJSON(object: any): ReferralCardBought {
    return {
      referralId: isSet(object.referral_id)
        ? globalThis.String(object.referral_id)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      cardSlugs: globalThis.Array.isArray(object?.card_slugs)
        ? object.card_slugs.map((e: any) => globalThis.String(e))
        : [],
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      playerSlugs: globalThis.Array.isArray(object?.player_slugs)
        ? object.player_slugs.map((e: any) => globalThis.String(e))
        : [],
      playerSlug: isSet(object.player_slug)
        ? globalThis.String(object.player_slug)
        : '',
      positions: globalThis.Array.isArray(object?.positions)
        ? object.positions.map((e: any) => globalThis.String(e))
        : [],
      season: isSet(object.season) ? globalThis.Number(object.season) : 0,
      teamSlug: isSet(object.team_slug)
        ? globalThis.String(object.team_slug)
        : '',
      cardCount: isSet(object.card_count)
        ? globalThis.Number(object.card_count)
        : 0,
      limited: isSet(object.limited) ? globalThis.Number(object.limited) : 0,
      rare: isSet(object.rare) ? globalThis.Number(object.rare) : 0,
      superRare: isSet(object.super_rare)
        ? globalThis.Number(object.super_rare)
        : 0,
      unique: isSet(object.unique) ? globalThis.Number(object.unique) : 0,
      auctionId: isSet(object.auction_id)
        ? globalThis.String(object.auction_id)
        : '',
      primaryOfferId: isSet(object.primary_offer_id)
        ? globalThis.String(object.primary_offer_id)
        : '',
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      conversionCreditEthAmount: isSet(object.conversion_credit_eth_amount)
        ? globalThis.Number(object.conversion_credit_eth_amount)
        : 0,
      conversionCreditEurAmount: isSet(object.conversion_credit_eur_amount)
        ? globalThis.Number(object.conversion_credit_eur_amount)
        : 0,
      fiatPayment: isSet(object.fiat_payment)
        ? globalThis.Boolean(object.fiat_payment)
        : false,
      secondary: isSet(object.secondary)
        ? globalThis.Boolean(object.secondary)
        : false,
      footballCardsBought: isSet(object.football_cards_bought)
        ? globalThis.Number(object.football_cards_bought)
        : 0,
      baseballCardsBought: isSet(object.baseball_cards_bought)
        ? globalThis.Number(object.baseball_cards_bought)
        : 0,
      nbaCardsBought: isSet(object.nba_cards_bought)
        ? globalThis.Number(object.nba_cards_bought)
        : 0,
    };
  },

  toJSON(message: ReferralCardBought): unknown {
    const obj: any = {};
    if (message.referralId !== undefined) {
      obj.referral_id = message.referralId;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.cardSlugs?.length) {
      obj.card_slugs = message.cardSlugs;
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.playerSlugs?.length) {
      obj.player_slugs = message.playerSlugs;
    }
    if (message.playerSlug !== undefined) {
      obj.player_slug = message.playerSlug;
    }
    if (message.positions?.length) {
      obj.positions = message.positions;
    }
    if (message.season !== undefined) {
      obj.season = Math.round(message.season);
    }
    if (message.teamSlug !== undefined) {
      obj.team_slug = message.teamSlug;
    }
    if (message.cardCount !== undefined) {
      obj.card_count = Math.round(message.cardCount);
    }
    if (message.limited !== undefined) {
      obj.limited = Math.round(message.limited);
    }
    if (message.rare !== undefined) {
      obj.rare = Math.round(message.rare);
    }
    if (message.superRare !== undefined) {
      obj.super_rare = Math.round(message.superRare);
    }
    if (message.unique !== undefined) {
      obj.unique = Math.round(message.unique);
    }
    if (message.auctionId !== undefined) {
      obj.auction_id = message.auctionId;
    }
    if (message.primaryOfferId !== undefined) {
      obj.primary_offer_id = message.primaryOfferId;
    }
    if (message.count !== undefined) {
      obj.count = Math.round(message.count);
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = message.ethAmount;
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = message.eurAmount;
    }
    if (message.conversionCreditEthAmount !== undefined) {
      obj.conversion_credit_eth_amount = message.conversionCreditEthAmount;
    }
    if (message.conversionCreditEurAmount !== undefined) {
      obj.conversion_credit_eur_amount = message.conversionCreditEurAmount;
    }
    if (message.fiatPayment !== undefined) {
      obj.fiat_payment = message.fiatPayment;
    }
    if (message.secondary !== undefined) {
      obj.secondary = message.secondary;
    }
    if (message.footballCardsBought !== undefined) {
      obj.football_cards_bought = Math.round(message.footballCardsBought);
    }
    if (message.baseballCardsBought !== undefined) {
      obj.baseball_cards_bought = Math.round(message.baseballCardsBought);
    }
    if (message.nbaCardsBought !== undefined) {
      obj.nba_cards_bought = Math.round(message.nbaCardsBought);
    }
    return obj;
  },
};

export const ReferralCompleted: MessageFns<ReferralCompleted> = {
  fromJSON(object: any): ReferralCompleted {
    return {
      referralId: isSet(object.referral_id)
        ? globalThis.String(object.referral_id)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      footballCardsBought: isSet(object.football_cards_bought)
        ? globalThis.Number(object.football_cards_bought)
        : 0,
      baseballCardsBought: isSet(object.baseball_cards_bought)
        ? globalThis.Number(object.baseball_cards_bought)
        : 0,
      nbaCardsBought: isSet(object.nba_cards_bought)
        ? globalThis.Number(object.nba_cards_bought)
        : 0,
    };
  },

  toJSON(message: ReferralCompleted): unknown {
    const obj: any = {};
    if (message.referralId !== undefined) {
      obj.referral_id = message.referralId;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.footballCardsBought !== undefined) {
      obj.football_cards_bought = Math.round(message.footballCardsBought);
    }
    if (message.baseballCardsBought !== undefined) {
      obj.baseball_cards_bought = Math.round(message.baseballCardsBought);
    }
    if (message.nbaCardsBought !== undefined) {
      obj.nba_cards_bought = Math.round(message.nbaCardsBought);
    }
    return obj;
  },
};

export const ReferralRewardSent: MessageFns<ReferralRewardSent> = {
  fromJSON(object: any): ReferralRewardSent {
    return {
      referralId: isSet(object.referral_id)
        ? globalThis.String(object.referral_id)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      playerSlug: isSet(object.player_slug)
        ? globalThis.String(object.player_slug)
        : '',
      positions: globalThis.Array.isArray(object?.positions)
        ? object.positions.map((e: any) => globalThis.String(e))
        : [],
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      season: isSet(object.season) ? globalThis.Number(object.season) : 0,
      serialNumber: isSet(object.serial_number)
        ? globalThis.Number(object.serial_number)
        : 0,
      teamSlug: isSet(object.team_slug)
        ? globalThis.String(object.team_slug)
        : '',
      position: isSet(object.position)
        ? globalThis.String(object.position)
        : '',
      conversionCreditEurAmount: isSet(object.conversion_credit_eur_amount)
        ? globalThis.Number(object.conversion_credit_eur_amount)
        : 0,
      conversionCreditPercentageDiscount: isSet(
        object.conversion_credit_percentage_discount
      )
        ? globalThis.Number(object.conversion_credit_percentage_discount)
        : 0,
      conversionCreditDuration: isSet(object.conversion_credit_duration)
        ? globalThis.Number(object.conversion_credit_duration)
        : 0,
    };
  },

  toJSON(message: ReferralRewardSent): unknown {
    const obj: any = {};
    if (message.referralId !== undefined) {
      obj.referral_id = message.referralId;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.playerSlug !== undefined) {
      obj.player_slug = message.playerSlug;
    }
    if (message.positions?.length) {
      obj.positions = message.positions;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.season !== undefined) {
      obj.season = Math.round(message.season);
    }
    if (message.serialNumber !== undefined) {
      obj.serial_number = Math.round(message.serialNumber);
    }
    if (message.teamSlug !== undefined) {
      obj.team_slug = message.teamSlug;
    }
    if (message.position !== undefined) {
      obj.position = message.position;
    }
    if (message.conversionCreditEurAmount !== undefined) {
      obj.conversion_credit_eur_amount = Math.round(
        message.conversionCreditEurAmount
      );
    }
    if (message.conversionCreditPercentageDiscount !== undefined) {
      obj.conversion_credit_percentage_discount = Math.round(
        message.conversionCreditPercentageDiscount
      );
    }
    if (message.conversionCreditDuration !== undefined) {
      obj.conversion_credit_duration = Math.round(
        message.conversionCreditDuration
      );
    }
    return obj;
  },
};

export const ClickListAgain: MessageFns<ClickListAgain> = {
  fromJSON(object: any): ClickListAgain {
    return {
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
    };
  },

  toJSON(message: ClickListAgain): unknown {
    const obj: any = {};
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    return obj;
  },
};

export const UserFlagToggled: MessageFns<UserFlagToggled> = {
  fromJSON(object: any): UserFlagToggled {
    return { flag: isSet(object.flag) ? globalThis.String(object.flag) : '' };
  },

  toJSON(message: UserFlagToggled): unknown {
    const obj: any = {};
    if (message.flag !== undefined) {
      obj.flag = message.flag;
    }
    return obj;
  },
};

export const ClickTrade: MessageFns<ClickTrade> = {
  fromJSON(object: any): ClickTrade {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      offerId: isSet(object.offer_id) ? globalThis.String(object.offer_id) : '',
    };
  },

  toJSON(message: ClickTrade): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    return obj;
  },
};

export const ChooseSignupSport: MessageFns<ChooseSignupSport> = {
  fromJSON(object: any): ChooseSignupSport {
    return { sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0 };
  },

  toJSON(message: ChooseSignupSport): unknown {
    const obj: any = {};
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ChooseSignupManagerName: MessageFns<ChooseSignupManagerName> = {
  fromJSON(_: any): ChooseSignupManagerName {
    return {};
  },

  toJSON(_: ChooseSignupManagerName): unknown {
    const obj: any = {};
    return obj;
  },
};

export const FailSignupManagerName: MessageFns<FailSignupManagerName> = {
  fromJSON(_: any): FailSignupManagerName {
    return {};
  },

  toJSON(_: FailSignupManagerName): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ClickSignupByEmail: MessageFns<ClickSignupByEmail> = {
  fromJSON(_: any): ClickSignupByEmail {
    return {};
  },

  toJSON(_: ClickSignupByEmail): unknown {
    const obj: any = {};
    return obj;
  },
};

export const FailSignupByEmail: MessageFns<FailSignupByEmail> = {
  fromJSON(_: any): FailSignupByEmail {
    return {};
  },

  toJSON(_: FailSignupByEmail): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ClickSignupByOAuth: MessageFns<ClickSignupByOAuth> = {
  fromJSON(object: any): ClickSignupByOAuth {
    return {
      provider: isSet(object.provider)
        ? globalThis.String(object.provider)
        : '',
    };
  },

  toJSON(message: ClickSignupByOAuth): unknown {
    const obj: any = {};
    if (message.provider !== undefined) {
      obj.provider = message.provider;
    }
    return obj;
  },
};

export const SubmitSignUpForm: MessageFns<SubmitSignUpForm> = {
  fromJSON(object: any): SubmitSignUpForm {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
    };
  },

  toJSON(message: SubmitSignUpForm): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    return obj;
  },
};

export const ClearMarketFilters: MessageFns<ClearMarketFilters> = {
  fromJSON(object: any): ClearMarketFilters {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      filtersCount: isSet(object.filters_count)
        ? globalThis.Number(object.filters_count)
        : 0,
    };
  },

  toJSON(message: ClearMarketFilters): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.filtersCount !== undefined) {
      obj.filters_count = Math.round(message.filtersCount);
    }
    return obj;
  },
};

export const RemoveMarketFilterChip: MessageFns<RemoveMarketFilterChip> = {
  fromJSON(object: any): RemoveMarketFilterChip {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      filterName: isSet(object.filter_name)
        ? globalThis.String(object.filter_name)
        : '',
      filterValue: isSet(object.filter_value)
        ? globalThis.String(object.filter_value)
        : '',
    };
  },

  toJSON(message: RemoveMarketFilterChip): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.filterName !== undefined) {
      obj.filter_name = message.filterName;
    }
    if (message.filterValue !== undefined) {
      obj.filter_value = message.filterValue;
    }
    return obj;
  },
};

export const SetDefaultMarketFilters: MessageFns<SetDefaultMarketFilters> = {
  fromJSON(object: any): SetDefaultMarketFilters {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      filters: isObject(object.filters)
        ? Object.entries(object.filters).reduce<{ [key: string]: string }>(
            (acc, [key, value]) => {
              acc[key] = String(value);
              return acc;
            },
            {}
          )
        : {},
    };
  },

  toJSON(message: SetDefaultMarketFilters): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.filters) {
      const entries = Object.entries(message.filters);
      if (entries.length > 0) {
        obj.filters = {};
        entries.forEach(([k, v]) => {
          obj.filters[k] = v;
        });
      }
    }
    return obj;
  },
};

export const SetDefaultMarketFilters_FiltersEntry: MessageFns<SetDefaultMarketFilters_FiltersEntry> =
  {
    fromJSON(object: any): SetDefaultMarketFilters_FiltersEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : '',
        value: isSet(object.value) ? globalThis.String(object.value) : '',
      };
    },

    toJSON(message: SetDefaultMarketFilters_FiltersEntry): unknown {
      const obj: any = {};
      if (message.key !== undefined) {
        obj.key = message.key;
      }
      if (message.value !== undefined) {
        obj.value = message.value;
      }
      return obj;
    },
  };

export const ClearDefaultMarketFilters: MessageFns<ClearDefaultMarketFilters> =
  {
    fromJSON(object: any): ClearDefaultMarketFilters {
      return {
        interactionContext: isSet(object.interaction_context)
          ? globalThis.String(object.interaction_context)
          : '',
        sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      };
    },

    toJSON(message: ClearDefaultMarketFilters): unknown {
      const obj: any = {};
      if (message.interactionContext !== undefined) {
        obj.interaction_context = message.interactionContext;
      }
      if (message.sport !== undefined) {
        obj.sport = sportToJSON(message.sport);
      }
      return obj;
    },
  };

export const ConfirmPurchaseForm: MessageFns<ConfirmPurchaseForm> = {
  fromJSON(object: any): ConfirmPurchaseForm {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      fiatPayment: isSet(object.fiat_payment)
        ? globalThis.Boolean(object.fiat_payment)
        : false,
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      offerId: isSet(object.offer_id) ? globalThis.String(object.offer_id) : '',
      isV2: isSet(object.is_v2) ? globalThis.Boolean(object.is_v2) : undefined,
    };
  },

  toJSON(message: ConfirmPurchaseForm): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = message.ethAmount;
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = message.eurAmount;
    }
    if (message.fiatPayment !== undefined) {
      obj.fiat_payment = message.fiatPayment;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    if (message.isV2 !== undefined) {
      obj.is_v2 = message.isV2;
    }
    return obj;
  },
};

export const ClickAnnouncementLink: MessageFns<ClickAnnouncementLink> = {
  fromJSON(object: any): ClickAnnouncementLink {
    return {
      announcementId: isSet(object.announcement_id)
        ? globalThis.String(object.announcement_id)
        : '',
      announcementTitle: isSet(object.announcement_title)
        ? globalThis.String(object.announcement_title)
        : '',
      linkHref: isSet(object.link_href)
        ? globalThis.String(object.link_href)
        : '',
    };
  },

  toJSON(message: ClickAnnouncementLink): unknown {
    const obj: any = {};
    if (message.announcementId !== undefined) {
      obj.announcement_id = message.announcementId;
    }
    if (message.announcementTitle !== undefined) {
      obj.announcement_title = message.announcementTitle;
    }
    if (message.linkHref !== undefined) {
      obj.link_href = message.linkHref;
    }
    return obj;
  },
};

export const CreateSavedSearch: MessageFns<CreateSavedSearch> = {
  fromJSON(object: any): CreateSavedSearch {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      filters: isObject(object.filters)
        ? Object.entries(object.filters).reduce<{ [key: string]: string }>(
            (acc, [key, value]) => {
              acc[key] = String(value);
              return acc;
            },
            {}
          )
        : {},
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: CreateSavedSearch): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.filters) {
      const entries = Object.entries(message.filters);
      if (entries.length > 0) {
        obj.filters = {};
        entries.forEach(([k, v]) => {
          obj.filters[k] = v;
        });
      }
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const CreateSavedSearch_FiltersEntry: MessageFns<CreateSavedSearch_FiltersEntry> =
  {
    fromJSON(object: any): CreateSavedSearch_FiltersEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : '',
        value: isSet(object.value) ? globalThis.String(object.value) : '',
      };
    },

    toJSON(message: CreateSavedSearch_FiltersEntry): unknown {
      const obj: any = {};
      if (message.key !== undefined) {
        obj.key = message.key;
      }
      if (message.value !== undefined) {
        obj.value = message.value;
      }
      return obj;
    },
  };

export const SelectSavedSearch: MessageFns<SelectSavedSearch> = {
  fromJSON(object: any): SelectSavedSearch {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      filters: isObject(object.filters)
        ? Object.entries(object.filters).reduce<{ [key: string]: string }>(
            (acc, [key, value]) => {
              acc[key] = String(value);
              return acc;
            },
            {}
          )
        : {},
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: SelectSavedSearch): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.filters) {
      const entries = Object.entries(message.filters);
      if (entries.length > 0) {
        obj.filters = {};
        entries.forEach(([k, v]) => {
          obj.filters[k] = v;
        });
      }
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const SelectSavedSearch_FiltersEntry: MessageFns<SelectSavedSearch_FiltersEntry> =
  {
    fromJSON(object: any): SelectSavedSearch_FiltersEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : '',
        value: isSet(object.value) ? globalThis.String(object.value) : '',
      };
    },

    toJSON(message: SelectSavedSearch_FiltersEntry): unknown {
      const obj: any = {};
      if (message.key !== undefined) {
        obj.key = message.key;
      }
      if (message.value !== undefined) {
        obj.value = message.value;
      }
      return obj;
    },
  };

export const DeleteSavedSearch: MessageFns<DeleteSavedSearch> = {
  fromJSON(object: any): DeleteSavedSearch {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      filters: isObject(object.filters)
        ? Object.entries(object.filters).reduce<{ [key: string]: string }>(
            (acc, [key, value]) => {
              acc[key] = String(value);
              return acc;
            },
            {}
          )
        : {},
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: DeleteSavedSearch): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.filters) {
      const entries = Object.entries(message.filters);
      if (entries.length > 0) {
        obj.filters = {};
        entries.forEach(([k, v]) => {
          obj.filters[k] = v;
        });
      }
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const DeleteSavedSearch_FiltersEntry: MessageFns<DeleteSavedSearch_FiltersEntry> =
  {
    fromJSON(object: any): DeleteSavedSearch_FiltersEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : '',
        value: isSet(object.value) ? globalThis.String(object.value) : '',
      };
    },

    toJSON(message: DeleteSavedSearch_FiltersEntry): unknown {
      const obj: any = {};
      if (message.key !== undefined) {
        obj.key = message.key;
      }
      if (message.value !== undefined) {
        obj.value = message.value;
      }
      return obj;
    },
  };

export const SwitchStackedView: MessageFns<SwitchStackedView> = {
  fromJSON(object: any): SwitchStackedView {
    return {
      stacked: isSet(object.stacked)
        ? globalThis.Boolean(object.stacked)
        : false,
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: SwitchStackedView): unknown {
    const obj: any = {};
    if (message.stacked !== undefined) {
      obj.stacked = message.stacked;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickStack: MessageFns<ClickStack> = {
  fromJSON(object: any): ClickStack {
    return {
      playerSlug: isSet(object.player_slug)
        ? globalThis.String(object.player_slug)
        : '',
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      season: isSet(object.season) ? globalThis.Number(object.season) : 0,
      teamSlug: isSet(object.team_slug)
        ? globalThis.String(object.team_slug)
        : '',
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickStack): unknown {
    const obj: any = {};
    if (message.playerSlug !== undefined) {
      obj.player_slug = message.playerSlug;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.season !== undefined) {
      obj.season = Math.round(message.season);
    }
    if (message.teamSlug !== undefined) {
      obj.team_slug = message.teamSlug;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickMarketTrend: MessageFns<ClickMarketTrend> = {
  fromJSON(object: any): ClickMarketTrend {
    return {
      timeframe: isSet(object.timeframe)
        ? globalThis.String(object.timeframe)
        : '',
      trend: isSet(object.trend) ? globalThis.String(object.trend) : '',
      slug: isSet(object.slug) ? globalThis.String(object.slug) : '',
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickMarketTrend): unknown {
    const obj: any = {};
    if (message.timeframe !== undefined) {
      obj.timeframe = message.timeframe;
    }
    if (message.trend !== undefined) {
      obj.trend = message.trend;
    }
    if (message.slug !== undefined) {
      obj.slug = message.slug;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const LoadMarketTrends: MessageFns<LoadMarketTrends> = {
  fromJSON(object: any): LoadMarketTrends {
    return {
      timeframe: isSet(object.timeframe)
        ? globalThis.String(object.timeframe)
        : '',
      sales: globalThis.Array.isArray(object?.sales)
        ? object.sales.map((e: any) => globalThis.String(e))
        : [],
      onTheRise: globalThis.Array.isArray(object?.on_the_rise)
        ? object.on_the_rise.map((e: any) => globalThis.String(e))
        : [],
      volumes: globalThis.Array.isArray(object?.volumes)
        ? object.volumes.map((e: any) => globalThis.String(e))
        : [],
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: LoadMarketTrends): unknown {
    const obj: any = {};
    if (message.timeframe !== undefined) {
      obj.timeframe = message.timeframe;
    }
    if (message.sales?.length) {
      obj.sales = message.sales;
    }
    if (message.onTheRise?.length) {
      obj.on_the_rise = message.onTheRise;
    }
    if (message.volumes?.length) {
      obj.volumes = message.volumes;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const UserCategoryUpdated: MessageFns<UserCategoryUpdated> = {
  fromJSON(object: any): UserCategoryUpdated {
    return {
      category: isSet(object.category)
        ? globalThis.String(object.category)
        : '',
    };
  },

  toJSON(message: UserCategoryUpdated): unknown {
    const obj: any = {};
    if (message.category !== undefined) {
      obj.category = message.category;
    }
    return obj;
  },
};

export const KycDocumentSubmitted: MessageFns<KycDocumentSubmitted> = {
  fromJSON(object: any): KycDocumentSubmitted {
    return {
      country: isSet(object.country) ? globalThis.String(object.country) : '',
      documentType: isSet(object.document_type)
        ? globalThis.String(object.document_type)
        : '',
    };
  },

  toJSON(message: KycDocumentSubmitted): unknown {
    const obj: any = {};
    if (message.country !== undefined) {
      obj.country = message.country;
    }
    if (message.documentType !== undefined) {
      obj.document_type = message.documentType;
    }
    return obj;
  },
};

export const KycDocumentRefused: MessageFns<KycDocumentRefused> = {
  fromJSON(object: any): KycDocumentRefused {
    return {
      country: isSet(object.country) ? globalThis.String(object.country) : '',
      documentType: isSet(object.document_type)
        ? globalThis.String(object.document_type)
        : '',
      reasonType: isSet(object.reason_type)
        ? globalThis.String(object.reason_type)
        : '',
    };
  },

  toJSON(message: KycDocumentRefused): unknown {
    const obj: any = {};
    if (message.country !== undefined) {
      obj.country = message.country;
    }
    if (message.documentType !== undefined) {
      obj.document_type = message.documentType;
    }
    if (message.reasonType !== undefined) {
      obj.reason_type = message.reasonType;
    }
    return obj;
  },
};

export const FailCardRegistration: MessageFns<FailCardRegistration> = {
  fromJSON(object: any): FailCardRegistration {
    return {
      cardType: isSet(object.card_type)
        ? globalThis.String(object.card_type)
        : '',
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: FailCardRegistration): unknown {
    const obj: any = {};
    if (message.cardType !== undefined) {
      obj.card_type = message.cardType;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickReferralBanner: MessageFns<ClickReferralBanner> = {
  fromJSON(object: any): ClickReferralBanner {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickReferralBanner): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const CampaignPageVisited: MessageFns<CampaignPageVisited> = {
  fromJSON(object: any): CampaignPageVisited {
    return {
      url: isSet(object.url) ? globalThis.String(object.url) : '',
      fingerprint: isSet(object.fingerprint)
        ? globalThis.String(object.fingerprint)
        : '',
      identifierType: isSet(object.identifier_type)
        ? globalThis.String(object.identifier_type)
        : '',
    };
  },

  toJSON(message: CampaignPageVisited): unknown {
    const obj: any = {};
    if (message.url !== undefined) {
      obj.url = message.url;
    }
    if (message.fingerprint !== undefined) {
      obj.fingerprint = message.fingerprint;
    }
    if (message.identifierType !== undefined) {
      obj.identifier_type = message.identifierType;
    }
    return obj;
  },
};

export const ClickScoutCards: MessageFns<ClickScoutCards> = {
  fromJSON(object: any): ClickScoutCards {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      playerSlug: isSet(object.player_slug)
        ? globalThis.String(object.player_slug)
        : '',
    };
  },

  toJSON(message: ClickScoutCards): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.playerSlug !== undefined) {
      obj.player_slug = message.playerSlug;
    }
    return obj;
  },
};

export const ClickSeeAllAvailableCards: MessageFns<ClickSeeAllAvailableCards> =
  {
    fromJSON(object: any): ClickSeeAllAvailableCards {
      return {
        interactionContext: isSet(object.interaction_context)
          ? globalThis.String(object.interaction_context)
          : '',
        sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
        eventName: isSet(object.event_name)
          ? globalThis.String(object.event_name)
          : '',
        eventType: isSet(object.event_type)
          ? globalThis.String(object.event_type)
          : '',
      };
    },

    toJSON(message: ClickSeeAllAvailableCards): unknown {
      const obj: any = {};
      if (message.interactionContext !== undefined) {
        obj.interaction_context = message.interactionContext;
      }
      if (message.sport !== undefined) {
        obj.sport = sportToJSON(message.sport);
      }
      if (message.eventName !== undefined) {
        obj.event_name = message.eventName;
      }
      if (message.eventType !== undefined) {
        obj.event_type = message.eventType;
      }
      return obj;
    },
  };

export const ClickSeeOtherListingsFromEndedAuction: MessageFns<ClickSeeOtherListingsFromEndedAuction> =
  {
    fromJSON(_: any): ClickSeeOtherListingsFromEndedAuction {
      return {};
    },

    toJSON(_: ClickSeeOtherListingsFromEndedAuction): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ViewBlogPost: MessageFns<ViewBlogPost> = {
  fromJSON(object: any): ViewBlogPost {
    return { slug: isSet(object.slug) ? globalThis.String(object.slug) : '' };
  },

  toJSON(message: ViewBlogPost): unknown {
    const obj: any = {};
    if (message.slug !== undefined) {
      obj.slug = message.slug;
    }
    return obj;
  },
};

export const ReadBlogPost: MessageFns<ReadBlogPost> = {
  fromJSON(object: any): ReadBlogPost {
    return { slug: isSet(object.slug) ? globalThis.String(object.slug) : '' };
  },

  toJSON(message: ReadBlogPost): unknown {
    const obj: any = {};
    if (message.slug !== undefined) {
      obj.slug = message.slug;
    }
    return obj;
  },
};

export const ClickHelp: MessageFns<ClickHelp> = {
  fromJSON(object: any): ClickHelp {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickHelp): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ViewHelpCenterArticle: MessageFns<ViewHelpCenterArticle> = {
  fromJSON(object: any): ViewHelpCenterArticle {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      locale: isSet(object.locale) ? globalThis.String(object.locale) : '',
      title: isSet(object.title) ? globalThis.String(object.title) : '',
    };
  },

  toJSON(message: ViewHelpCenterArticle): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.locale !== undefined) {
      obj.locale = message.locale;
    }
    if (message.title !== undefined) {
      obj.title = message.title;
    }
    return obj;
  },
};

export const ClickOpenMobileApp: MessageFns<ClickOpenMobileApp> = {
  fromJSON(object: any): ClickOpenMobileApp {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      platform: isSet(object.platform)
        ? globalThis.String(object.platform)
        : '',
    };
  },

  toJSON(message: ClickOpenMobileApp): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.platform !== undefined) {
      obj.platform = message.platform;
    }
    return obj;
  },
};

export const ClosePromoteMobileApp: MessageFns<ClosePromoteMobileApp> = {
  fromJSON(object: any): ClosePromoteMobileApp {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      platform: isSet(object.platform)
        ? globalThis.String(object.platform)
        : '',
    };
  },

  toJSON(message: ClosePromoteMobileApp): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.platform !== undefined) {
      obj.platform = message.platform;
    }
    return obj;
  },
};

export const EnterCashWalletKYCFlow: MessageFns<EnterCashWalletKYCFlow> = {
  fromJSON(object: any): EnterCashWalletKYCFlow {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      source: isSet(object.source)
        ? enterCashWalletKYCFlow_SourceFromJSON(object.source)
        : 0,
      target: isSet(object.target)
        ? enterCashWalletKYCFlow_TargetFromJSON(object.target)
        : 0,
      cashWalletStatus: isSet(object.cash_wallet_status)
        ? cashWalletStatusFromJSON(object.cash_wallet_status)
        : 0,
      fiatCurrency: isSet(object.fiat_currency)
        ? globalThis.String(object.fiat_currency)
        : '',
    };
  },

  toJSON(message: EnterCashWalletKYCFlow): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.source !== undefined) {
      obj.source = enterCashWalletKYCFlow_SourceToJSON(message.source);
    }
    if (message.target !== undefined) {
      obj.target = enterCashWalletKYCFlow_TargetToJSON(message.target);
    }
    if (message.cashWalletStatus !== undefined) {
      obj.cash_wallet_status = cashWalletStatusToJSON(message.cashWalletStatus);
    }
    if (message.fiatCurrency !== undefined) {
      obj.fiat_currency = message.fiatCurrency;
    }
    return obj;
  },
};

export const ExitCashWalletKYCFlow: MessageFns<ExitCashWalletKYCFlow> = {
  fromJSON(object: any): ExitCashWalletKYCFlow {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      kycExitStep: isSet(object.kyc_exit_step)
        ? exitCashWalletKYCFlow_ExitStepFromJSON(object.kyc_exit_step)
        : 0,
      cashWalletStatus: isSet(object.cash_wallet_status)
        ? cashWalletStatusFromJSON(object.cash_wallet_status)
        : 0,
      fiatCurrency: isSet(object.fiat_currency)
        ? globalThis.String(object.fiat_currency)
        : '',
    };
  },

  toJSON(message: ExitCashWalletKYCFlow): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.kycExitStep !== undefined) {
      obj.kyc_exit_step = exitCashWalletKYCFlow_ExitStepToJSON(
        message.kycExitStep
      );
    }
    if (message.cashWalletStatus !== undefined) {
      obj.cash_wallet_status = cashWalletStatusToJSON(message.cashWalletStatus);
    }
    if (message.fiatCurrency !== undefined) {
      obj.fiat_currency = message.fiatCurrency;
    }
    return obj;
  },
};

export const ClickMarketTrendsLink: MessageFns<ClickMarketTrendsLink> = {
  fromJSON(object: any): ClickMarketTrendsLink {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      tileType: isSet(object.tile_type)
        ? clickMarketTrendsLink_TileTypeFromJSON(object.tile_type)
        : 0,
      playerSlug: isSet(object.player_slug)
        ? globalThis.String(object.player_slug)
        : undefined,
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : undefined,
      serialNumber: isSet(object.serial_number)
        ? globalThis.Number(object.serial_number)
        : undefined,
      gameWeek: isSet(object.game_week)
        ? globalThis.Number(object.game_week)
        : undefined,
      heuristic: isSet(object.heuristic)
        ? clickMarketTrendsLink_ForYouHeuristicFromJSON(object.heuristic)
        : 0,
      so5LeagueSlug: isSet(object.so5_league_slug)
        ? globalThis.String(object.so5_league_slug)
        : undefined,
      userSlug: isSet(object.user_slug)
        ? globalThis.String(object.user_slug)
        : undefined,
    };
  },

  toJSON(message: ClickMarketTrendsLink): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.tileType !== undefined) {
      obj.tile_type = clickMarketTrendsLink_TileTypeToJSON(message.tileType);
    }
    if (message.playerSlug !== undefined) {
      obj.player_slug = message.playerSlug;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.serialNumber !== undefined) {
      obj.serial_number = Math.round(message.serialNumber);
    }
    if (message.gameWeek !== undefined) {
      obj.game_week = Math.round(message.gameWeek);
    }
    if (message.heuristic !== undefined) {
      obj.heuristic = clickMarketTrendsLink_ForYouHeuristicToJSON(
        message.heuristic
      );
    }
    if (message.so5LeagueSlug !== undefined) {
      obj.so5_league_slug = message.so5LeagueSlug;
    }
    if (message.userSlug !== undefined) {
      obj.user_slug = message.userSlug;
    }
    return obj;
  },
};

export const ClickAddMoney: MessageFns<ClickAddMoney> = {
  fromJSON(object: any): ClickAddMoney {
    return {
      wallet: isSet(object.wallet) ? walletFromJSON(object.wallet) : 0,
      currency: isSet(object.currency)
        ? fiatCurrencyFromJSON(object.currency)
        : undefined,
    };
  },

  toJSON(message: ClickAddMoney): unknown {
    const obj: any = {};
    if (message.wallet !== undefined) {
      obj.wallet = walletToJSON(message.wallet);
    }
    if (message.currency !== undefined) {
      obj.currency = fiatCurrencyToJSON(message.currency);
    }
    return obj;
  },
};

export const SelectDepositMethod: MessageFns<SelectDepositMethod> = {
  fromJSON(object: any): SelectDepositMethod {
    return {
      method: isSet(object.method) ? depositMethodFromJSON(object.method) : 0,
    };
  },

  toJSON(message: SelectDepositMethod): unknown {
    const obj: any = {};
    if (message.method !== undefined) {
      obj.method = depositMethodToJSON(message.method);
    }
    return obj;
  },
};

export const ClickReviewDeposit: MessageFns<ClickReviewDeposit> = {
  fromJSON(object: any): ClickReviewDeposit {
    return {
      method: isSet(object.method) ? depositMethodFromJSON(object.method) : 0,
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      currency: isSet(object.currency)
        ? fiatCurrencyFromJSON(object.currency)
        : 0,
      baseAmount: isSet(object.base_amount)
        ? globalThis.Number(object.base_amount)
        : undefined,
    };
  },

  toJSON(message: ClickReviewDeposit): unknown {
    const obj: any = {};
    if (message.method !== undefined) {
      obj.method = depositMethodToJSON(message.method);
    }
    if (message.amount !== undefined) {
      obj.amount = message.amount;
    }
    if (message.currency !== undefined) {
      obj.currency = fiatCurrencyToJSON(message.currency);
    }
    if (message.baseAmount !== undefined) {
      obj.base_amount = message.baseAmount;
    }
    return obj;
  },
};

export const ViewAddFundsToFiatWallet: MessageFns<ViewAddFundsToFiatWallet> = {
  fromJSON(object: any): ViewAddFundsToFiatWallet {
    return {
      currency: isSet(object.currency)
        ? fiatCurrencyFromJSON(object.currency)
        : 0,
      baseAmount: isSet(object.base_amount)
        ? globalThis.Number(object.base_amount)
        : undefined,
    };
  },

  toJSON(message: ViewAddFundsToFiatWallet): unknown {
    const obj: any = {};
    if (message.currency !== undefined) {
      obj.currency = fiatCurrencyToJSON(message.currency);
    }
    if (message.baseAmount !== undefined) {
      obj.base_amount = message.baseAmount;
    }
    return obj;
  },
};

export const ClickConfirmDesposit: MessageFns<ClickConfirmDesposit> = {
  fromJSON(object: any): ClickConfirmDesposit {
    return {
      method: isSet(object.method) ? depositMethodFromJSON(object.method) : 0,
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      currency: isSet(object.currency)
        ? fiatCurrencyFromJSON(object.currency)
        : 0,
    };
  },

  toJSON(message: ClickConfirmDesposit): unknown {
    const obj: any = {};
    if (message.method !== undefined) {
      obj.method = depositMethodToJSON(message.method);
    }
    if (message.amount !== undefined) {
      obj.amount = message.amount;
    }
    if (message.currency !== undefined) {
      obj.currency = fiatCurrencyToJSON(message.currency);
    }
    return obj;
  },
};

export const Display3ds: MessageFns<Display3ds> = {
  fromJSON(_: any): Display3ds {
    return {};
  },

  toJSON(_: Display3ds): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ClickPaypalDepositFromPayment: MessageFns<ClickPaypalDepositFromPayment> =
  {
    fromJSON(object: any): ClickPaypalDepositFromPayment {
      return {
        canDeposit: isSet(object.can_deposit)
          ? globalThis.Boolean(object.can_deposit)
          : false,
      };
    },

    toJSON(message: ClickPaypalDepositFromPayment): unknown {
      const obj: any = {};
      if (message.canDeposit !== undefined) {
        obj.can_deposit = message.canDeposit;
      }
      return obj;
    },
  };

export const SendDirectOffer: MessageFns<SendDirectOffer> = {
  fromJSON(object: any): SendDirectOffer {
    return {
      offerId: isSet(object.offer_id) ? globalThis.String(object.offer_id) : '',
    };
  },

  toJSON(message: SendDirectOffer): unknown {
    const obj: any = {};
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    return obj;
  },
};

export const AcceptDirectOffer: MessageFns<AcceptDirectOffer> = {
  fromJSON(object: any): AcceptDirectOffer {
    return {
      offerId: isSet(object.offer_id) ? globalThis.String(object.offer_id) : '',
    };
  },

  toJSON(message: AcceptDirectOffer): unknown {
    const obj: any = {};
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    return obj;
  },
};

export const ShowEnterPhoneNumber: MessageFns<ShowEnterPhoneNumber> = {
  fromJSON(_: any): ShowEnterPhoneNumber {
    return {};
  },

  toJSON(_: ShowEnterPhoneNumber): unknown {
    const obj: any = {};
    return obj;
  },
};

export const SubmitPhoneNumber: MessageFns<SubmitPhoneNumber> = {
  fromJSON(object: any): SubmitPhoneNumber {
    return {
      resend: isSet(object.resend)
        ? globalThis.Boolean(object.resend)
        : undefined,
    };
  },

  toJSON(message: SubmitPhoneNumber): unknown {
    const obj: any = {};
    if (message.resend !== undefined) {
      obj.resend = message.resend;
    }
    return obj;
  },
};

export const ShowEnterVerificationCode: MessageFns<ShowEnterVerificationCode> =
  {
    fromJSON(_: any): ShowEnterVerificationCode {
      return {};
    },

    toJSON(_: ShowEnterVerificationCode): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const SubmitPhoneVerificationCode: MessageFns<SubmitPhoneVerificationCode> =
  {
    fromJSON(_: any): SubmitPhoneVerificationCode {
      return {};
    },

    toJSON(_: SubmitPhoneVerificationCode): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickLobbyLiveOpsTile: MessageFns<ClickLobbyLiveOpsTile> = {
  fromJSON(object: any): ClickLobbyLiveOpsTile {
    return {
      tileId: isSet(object.tile_id) ? globalThis.String(object.tile_id) : '',
      tileTitle: isSet(object.tile_title)
        ? globalThis.String(object.tile_title)
        : '',
      tilePosition: isSet(object.tile_position)
        ? globalThis.Number(object.tile_position)
        : 0,
    };
  },

  toJSON(message: ClickLobbyLiveOpsTile): unknown {
    const obj: any = {};
    if (message.tileId !== undefined) {
      obj.tile_id = message.tileId;
    }
    if (message.tileTitle !== undefined) {
      obj.tile_title = message.tileTitle;
    }
    if (message.tilePosition !== undefined) {
      obj.tile_position = Math.round(message.tilePosition);
    }
    return obj;
  },
};

export const EnterFromAndroidMarketplaceTab: MessageFns<EnterFromAndroidMarketplaceTab> =
  {
    fromJSON(object: any): EnterFromAndroidMarketplaceTab {
      return {
        interactionContext: isSet(object.interaction_context)
          ? globalThis.String(object.interaction_context)
          : '',
        sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
        appBuildVersion: isSet(object.app_build_version)
          ? globalThis.String(object.app_build_version)
          : '',
        userSlug: isSet(object.user_slug)
          ? globalThis.String(object.user_slug)
          : undefined,
      };
    },

    toJSON(message: EnterFromAndroidMarketplaceTab): unknown {
      const obj: any = {};
      if (message.interactionContext !== undefined) {
        obj.interaction_context = message.interactionContext;
      }
      if (message.sport !== undefined) {
        obj.sport = sportToJSON(message.sport);
      }
      if (message.appBuildVersion !== undefined) {
        obj.app_build_version = message.appBuildVersion;
      }
      if (message.userSlug !== undefined) {
        obj.user_slug = message.userSlug;
      }
      return obj;
    },
  };

export const ClickHomepageCryptoWalletIcon: MessageFns<ClickHomepageCryptoWalletIcon> =
  {
    fromJSON(_: any): ClickHomepageCryptoWalletIcon {
      return {};
    },

    toJSON(_: ClickHomepageCryptoWalletIcon): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickHomepageCryptoWalletProvider: MessageFns<ClickHomepageCryptoWalletProvider> =
  {
    fromJSON(object: any): ClickHomepageCryptoWalletProvider {
      return {
        provider: isSet(object.provider)
          ? globalThis.String(object.provider)
          : '',
      };
    },

    toJSON(message: ClickHomepageCryptoWalletProvider): unknown {
      const obj: any = {};
      if (message.provider !== undefined) {
        obj.provider = message.provider;
      }
      return obj;
    },
  };

export const ClickNotification: MessageFns<ClickNotification> = {
  fromJSON(object: any): ClickNotification {
    return { name: isSet(object.name) ? globalThis.String(object.name) : '' };
  },

  toJSON(message: ClickNotification): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    return obj;
  },
};

export const ClickNextInDiscountScreen: MessageFns<ClickNextInDiscountScreen> =
  {
    fromJSON(_: any): ClickNextInDiscountScreen {
      return {};
    },

    toJSON(_: ClickNextInDiscountScreen): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickViewPlayersInDiscountScreen: MessageFns<ClickViewPlayersInDiscountScreen> =
  {
    fromJSON(_: any): ClickViewPlayersInDiscountScreen {
      return {};
    },

    toJSON(_: ClickViewPlayersInDiscountScreen): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickSkipInDiscountScreen: MessageFns<ClickSkipInDiscountScreen> =
  {
    fromJSON(_: any): ClickSkipInDiscountScreen {
      return {};
    },

    toJSON(_: ClickSkipInDiscountScreen): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickScoutInDiscountScreen: MessageFns<ClickScoutInDiscountScreen> =
  {
    fromJSON(_: any): ClickScoutInDiscountScreen {
      return {};
    },

    toJSON(_: ClickScoutInDiscountScreen): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickMissionButton: MessageFns<ClickMissionButton> = {
  fromJSON(object: any): ClickMissionButton {
    return {
      slug: isSet(object.slug) ? globalThis.String(object.slug) : '',
      onboarding: isSet(object.onboarding)
        ? globalThis.Boolean(object.onboarding)
        : false,
    };
  },

  toJSON(message: ClickMissionButton): unknown {
    const obj: any = {};
    if (message.slug !== undefined) {
      obj.slug = message.slug;
    }
    if (message.onboarding !== undefined) {
      obj.onboarding = message.onboarding;
    }
    return obj;
  },
};

export const ViewScrapScreen: MessageFns<ViewScrapScreen> = {
  fromJSON(object: any): ViewScrapScreen {
    return {
      cardsCount: isSet(object.cards_count)
        ? globalThis.Number(object.cards_count)
        : 0,
    };
  },

  toJSON(message: ViewScrapScreen): unknown {
    const obj: any = {};
    if (message.cardsCount !== undefined) {
      obj.cards_count = Math.round(message.cardsCount);
    }
    return obj;
  },
};

export const ClickContinueInChooseYourLevel: MessageFns<ClickContinueInChooseYourLevel> =
  {
    fromJSON(object: any): ClickContinueInChooseYourLevel {
      return {
        scarcity: isSet(object.scarcity)
          ? globalThis.String(object.scarcity)
          : '',
      };
    },

    toJSON(message: ClickContinueInChooseYourLevel): unknown {
      const obj: any = {};
      if (message.scarcity !== undefined) {
        obj.scarcity = message.scarcity;
      }
      return obj;
    },
  };

export const ClickNextInGuidanceTutorial: MessageFns<ClickNextInGuidanceTutorial> =
  {
    fromJSON(_: any): ClickNextInGuidanceTutorial {
      return {};
    },

    toJSON(_: ClickNextInGuidanceTutorial): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickRewardInfoInGuidanceTutorial: MessageFns<ClickRewardInfoInGuidanceTutorial> =
  {
    fromJSON(_: any): ClickRewardInfoInGuidanceTutorial {
      return {};
    },

    toJSON(_: ClickRewardInfoInGuidanceTutorial): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const SelectCompetitionInGuidance: MessageFns<SelectCompetitionInGuidance> =
  {
    fromJSON(object: any): SelectCompetitionInGuidance {
      return {
        competition: isSet(object.competition)
          ? globalThis.String(object.competition)
          : '',
      };
    },

    toJSON(message: SelectCompetitionInGuidance): unknown {
      const obj: any = {};
      if (message.competition !== undefined) {
        obj.competition = message.competition;
      }
      return obj;
    },
  };

export const ClickNextInGuidanceClubChoice: MessageFns<ClickNextInGuidanceClubChoice> =
  {
    fromJSON(object: any): ClickNextInGuidanceClubChoice {
      return {
        clubsCount: isSet(object.clubs_count)
          ? globalThis.Number(object.clubs_count)
          : 0,
        teamSlugs: globalThis.Array.isArray(object?.team_slugs)
          ? object.team_slugs.map((e: any) => globalThis.String(e))
          : [],
      };
    },

    toJSON(message: ClickNextInGuidanceClubChoice): unknown {
      const obj: any = {};
      if (message.clubsCount !== undefined) {
        obj.clubs_count = Math.round(message.clubsCount);
      }
      if (message.teamSlugs?.length) {
        obj.team_slugs = message.teamSlugs;
      }
      return obj;
    },
  };

export const ClickSkipInGuidanceTeam: MessageFns<ClickSkipInGuidanceTeam> = {
  fromJSON(_: any): ClickSkipInGuidanceTeam {
    return {};
  },

  toJSON(_: ClickSkipInGuidanceTeam): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ClickContinueInGuidanceTeam: MessageFns<ClickContinueInGuidanceTeam> =
  {
    fromJSON(_: any): ClickContinueInGuidanceTeam {
      return {};
    },

    toJSON(_: ClickContinueInGuidanceTeam): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const CheckPlayerDetailsInGuidanceTeam: MessageFns<CheckPlayerDetailsInGuidanceTeam> =
  {
    fromJSON(_: any): CheckPlayerDetailsInGuidanceTeam {
      return {};
    },

    toJSON(_: CheckPlayerDetailsInGuidanceTeam): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickEditTeamInGuidanceFirstLineup: MessageFns<ClickEditTeamInGuidanceFirstLineup> =
  {
    fromJSON(_: any): ClickEditTeamInGuidanceFirstLineup {
      return {};
    },

    toJSON(_: ClickEditTeamInGuidanceFirstLineup): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const CheckPlayerDetailsInGuidanceFirstLineup: MessageFns<CheckPlayerDetailsInGuidanceFirstLineup> =
  {
    fromJSON(_: any): CheckPlayerDetailsInGuidanceFirstLineup {
      return {};
    },

    toJSON(_: CheckPlayerDetailsInGuidanceFirstLineup): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickPrizePoolInGuidanceFirstLineup: MessageFns<ClickPrizePoolInGuidanceFirstLineup> =
  {
    fromJSON(_: any): ClickPrizePoolInGuidanceFirstLineup {
      return {};
    },

    toJSON(_: ClickPrizePoolInGuidanceFirstLineup): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickHelpCenterInGuidanceFirstLineup: MessageFns<ClickHelpCenterInGuidanceFirstLineup> =
  {
    fromJSON(_: any): ClickHelpCenterInGuidanceFirstLineup {
      return {};
    },

    toJSON(_: ClickHelpCenterInGuidanceFirstLineup): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickSwitchLeagueInGuidanceFirstLineup: MessageFns<ClickSwitchLeagueInGuidanceFirstLineup> =
  {
    fromJSON(_: any): ClickSwitchLeagueInGuidanceFirstLineup {
      return {};
    },

    toJSON(_: ClickSwitchLeagueInGuidanceFirstLineup): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickCommonInGuidanceFirstLineup: MessageFns<ClickCommonInGuidanceFirstLineup> =
  {
    fromJSON(_: any): ClickCommonInGuidanceFirstLineup {
      return {};
    },

    toJSON(_: ClickCommonInGuidanceFirstLineup): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickCheckoutInGuidanceFirstLineup: MessageFns<ClickCheckoutInGuidanceFirstLineup> =
  {
    fromJSON(_: any): ClickCheckoutInGuidanceFirstLineup {
      return {};
    },

    toJSON(_: ClickCheckoutInGuidanceFirstLineup): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const ClickShuffleInEditFirstLineup: MessageFns<ClickShuffleInEditFirstLineup> =
  {
    fromJSON(_: any): ClickShuffleInEditFirstLineup {
      return {};
    },

    toJSON(_: ClickShuffleInEditFirstLineup): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const SwapPlayerInEditFirstLineup: MessageFns<SwapPlayerInEditFirstLineup> =
  {
    fromJSON(object: any): SwapPlayerInEditFirstLineup {
      return {
        oldPlayer: isSet(object.old_player)
          ? globalThis.String(object.old_player)
          : '',
        newPlayer: isSet(object.new_player)
          ? globalThis.String(object.new_player)
          : '',
      };
    },

    toJSON(message: SwapPlayerInEditFirstLineup): unknown {
      const obj: any = {};
      if (message.oldPlayer !== undefined) {
        obj.old_player = message.oldPlayer;
      }
      if (message.newPlayer !== undefined) {
        obj.new_player = message.newPlayer;
      }
      return obj;
    },
  };

export const ClickLandingPagePromoBanner: MessageFns<ClickLandingPagePromoBanner> =
  {
    fromJSON(object: any): ClickLandingPagePromoBanner {
      return {
        clickSource: isSet(object.click_source)
          ? globalThis.String(object.click_source)
          : undefined,
      };
    },

    toJSON(message: ClickLandingPagePromoBanner): unknown {
      const obj: any = {};
      if (message.clickSource !== undefined) {
        obj.click_source = message.clickSource;
      }
      return obj;
    },
  };

export const ClickLandingPageScout: MessageFns<ClickLandingPageScout> = {
  fromJSON(object: any): ClickLandingPageScout {
    return {
      clickSource: isSet(object.click_source)
        ? globalThis.String(object.click_source)
        : undefined,
    };
  },

  toJSON(message: ClickLandingPageScout): unknown {
    const obj: any = {};
    if (message.clickSource !== undefined) {
      obj.click_source = message.clickSource;
    }
    return obj;
  },
};

export const ClickLandingPagePlay: MessageFns<ClickLandingPagePlay> = {
  fromJSON(object: any): ClickLandingPagePlay {
    return {
      clickSource: isSet(object.click_source)
        ? globalThis.String(object.click_source)
        : undefined,
    };
  },

  toJSON(message: ClickLandingPagePlay): unknown {
    const obj: any = {};
    if (message.clickSource !== undefined) {
      obj.click_source = message.clickSource;
    }
    return obj;
  },
};

export const ClickLandingPageWin: MessageFns<ClickLandingPageWin> = {
  fromJSON(object: any): ClickLandingPageWin {
    return {
      clickSource: isSet(object.click_source)
        ? globalThis.String(object.click_source)
        : undefined,
    };
  },

  toJSON(message: ClickLandingPageWin): unknown {
    const obj: any = {};
    if (message.clickSource !== undefined) {
      obj.click_source = message.clickSource;
    }
    return obj;
  },
};

export const LandingPageNicknameForm: MessageFns<LandingPageNicknameForm> = {
  fromJSON(object: any): LandingPageNicknameForm {
    return {
      source: isSet(object.source) ? globalThis.String(object.source) : '',
      status: isSet(object.status) ? globalThis.String(object.status) : '',
    };
  },

  toJSON(message: LandingPageNicknameForm): unknown {
    const obj: any = {};
    if (message.source !== undefined) {
      obj.source = message.source;
    }
    if (message.status !== undefined) {
      obj.status = message.status;
    }
    return obj;
  },
};

export const ClickSkipCollectionAnimation: MessageFns<ClickSkipCollectionAnimation> =
  {
    fromJSON(_: any): ClickSkipCollectionAnimation {
      return {};
    },

    toJSON(_: ClickSkipCollectionAnimation): unknown {
      const obj: any = {};
      return obj;
    },
  };

function isObject(value: any): boolean {
  return typeof value === 'object' && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
